/* Pelucci product gallery: swipe/scroll slider, dots, arrows, variant switching, full-screen view. */
(function () {
  function init(root) {
    if (root.__pgReady) return;
    root.__pgReady = true;

    var track = root.querySelector('.pl-gallery__track');
    var dots = root.querySelector('[data-pg-dots]');
    var prev = root.querySelector('[data-pg-prev]');
    var next = root.querySelector('[data-pg-next]');
    if (!track) return;

    var data = {};
    try {
      data = JSON.parse(root.querySelector('[data-pg-data]').textContent) || {};
    } catch (e) {}
    var all = Array.prototype.slice.call(track.children);
    var sectionEl = root.closest('[id^="MainProduct-"]') || document;
    var ticking = false;

    // Photos 3 onwards arrive with a blank placeholder (see snippets/pelucci-gallery-slide.liquid,
    // 14 Oct 2026) so they don't compete with the first photo while the page loads. This puts the
    // real photos in: on the first touch, swipe, arrow click or variant change, or once the page
    // has finished loading.
    function hydrate() {
      if (root.__pgHydrated) return;
      root.__pgHydrated = true;
      Array.prototype.forEach.call(root.querySelectorAll('img[data-pg-deferred]'), function (img) {
        if (img.dataset.pgSrcset) img.srcset = img.dataset.pgSrcset;
        if (img.dataset.pgSrc) img.src = img.dataset.pgSrc;
        img.removeAttribute('data-pg-deferred');
      });
    }

    function shown() {
      return Array.prototype.filter.call(track.children, function (li) {
        return !li.hidden;
      });
    }

    function index() {
      var w = track.clientWidth || 1;
      var n = shown().length;
      return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w)));
    }

    function update() {
      ticking = false;
      var list = shown();
      var i = index();
      var li = list[i];
      if (li && li.dataset.ratio) track.style.aspectRatio = li.dataset.ratio;
      if (dots) {
        Array.prototype.forEach.call(dots.children, function (dot, d) {
          dot.classList.toggle('is-active', d === i);
        });
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= list.length - 1;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function go(i) {
      hydrate();
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }

    function buildDots(n) {
      if (!dots) return;
      dots.innerHTML = '';
      for (var d = 0; d < n && n > 1; d++) {
        var dot = document.createElement('span');
        dot.className = 'pl-gallery__dot';
        dots.appendChild(dot);
      }
    }

    function find(id) {
      id = String(id);
      for (var a = 0; a < all.length; a++) {
        if (all[a].dataset.mediaId === id) return all[a];
      }
      return null;
    }

    function showVariant(variantId) {
      hydrate();
      variantId = String(variantId);
      var chosen = [];
      if (Array.isArray(data.mapping)) {
        for (var m = 0; m < data.mapping.length; m++) {
          if (String(data.mapping[m].id) === variantId) {
            (data.mapping[m].media || []).forEach(function (mediaId) {
              var li = find(mediaId);
              if (li && chosen.indexOf(li) === -1) chosen.push(li);
            });
            break;
          }
        }
      }
      if (!chosen.length) {
        var featured = data.featured && data.featured[variantId] ? find(data.featured[variantId]) : null;
        if (featured) chosen.push(featured);
        all.forEach(function (li) {
          if (chosen.indexOf(li) === -1) chosen.push(li);
        });
      }
      // Same photos already showing in the same order (for example another size of the
      // same colour): leave the page as it is.
      var current = shown();
      var unchanged = current.length === chosen.length && chosen.every(function (li, c) {
        return current[c] === li;
      });
      if (unchanged) return;
      all.forEach(function (li) {
        li.hidden = chosen.indexOf(li) === -1;
      });
      chosen.forEach(function (li) {
        track.appendChild(li);
      });
      track.scrollLeft = 0;
      root.classList.toggle('pl-gallery--single', chosen.length < 2);
      buildDots(chosen.length);
      update();
    }

    track.addEventListener('scroll', function () {
      hydrate();
      requestUpdate();
    }, { passive: true });
    root.addEventListener('pointerdown', hydrate, { passive: true });
    root.addEventListener('touchstart', hydrate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });

    function hydrateWhenIdle() {
      setTimeout(function () {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(hydrate, { timeout: 3000 });
        } else {
          hydrate();
        }
      }, 1500);
    }
    if (document.readyState === 'complete') {
      hydrateWhenIdle();
    } else {
      window.addEventListener('load', hydrateWhenIdle);
    }

    track.addEventListener('click', function (event) {
      var button = event.target.closest('.pl-gallery__zoom');
      if (!button) return;
      var modal = document.querySelector('#ProductModal-' + root.dataset.section);
      if (modal && typeof modal.show === 'function') modal.show(button);
    });

    // The page already arrives with the selected variant's photos first, so remember that
    // variant: the theme fires a "change" for it while loading and the photos must not be
    // re-ordered (and the main photo re-requested) for a variant that is already showing.
    var startInput = sectionEl.querySelector('form[id="product-form-' + (root.dataset.section || '') + '"] [name="id"]');
    if (startInput && startInput.value) root.__pgVariant = String(startInput.value);

    sectionEl.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.name !== 'id' || !input.value || !input.form) return;
      var formId = input.form.getAttribute('id') || '';
      var sid = root.dataset.section || '';
      if (sid) {
        if (formId !== 'product-form-' + sid && formId !== 'product-form-installment-' + sid) return;
      } else if (formId.indexOf('product-form-') !== 0) {
        return;
      }
      if (String(input.value) === root.__pgVariant) return;
      root.__pgVariant = String(input.value);
      showVariant(input.value);
    });

    update();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pl-gallery]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
